import React from 'react';
import { Box } from '@mui/material';
import { HomeHeader, QuickAccessSection } from './components';
import { useHome } from './hooks/useHome';
import { HOME_STYLES } from './constants/homeConstants';

const Home = ({ onLogout }) => {
  const { userLogged, handleLogout } = useHome(onLogout);

  return (
    <Box sx={HOME_STYLES.container}>
      <HomeHeader userLogged={userLogged} onLogout={handleLogout} />
      <QuickAccessSection />
    </Box>
  );
};

export default Home;
